// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Ceci7","block":"styles_block__y4Ag1"};